import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoginBannerImage3 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 69,
	height: 82,
	viewBox: "0 0 69 82",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 2147224443",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M13.2141 1.7408L1.33301 14.5231V80.4295H59.1442H63.7387V1.00024H68.0253V81",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M59.1429 76.3262V1.00027H15.6461V14.5231H4.12012",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M8.57617 24.6558H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M8.57617 30.394H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M8.57617 36.1328H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M8.57617 41.8716H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M8.57617 47.6108H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_8",
				d: "M8.57617 53.3496H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_9",
				d: "M8.57617 59.0879H53.5031",
				stroke: "white",
				strokeWidth: 1.3111
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_10",
				d: "M8.57617 64.8267H24.7174",
				stroke: "white",
				strokeWidth: 1.3111
			})
		]
	})
});
export default SvgLoginBannerImage3;
